// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"8880c69e03245801","9985":"53e2a3b31477ca62"}[chunkId] + ".css";
};